"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const productInfoContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs,
  width: "100%"
};
const ProductTitle = styled(Text, {
  shouldForwardProp: (props) => props !== "productTileMaxLineNumber"
})(({
  productTileMaxLineNumber = 3
}) => {
  return {
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: productTileMaxLineNumber,
    display: "-webkit-box",
    overflow: "hidden",
    width: "100%",
    wordBreak: "break-word"
  };
});
export {
  ProductTitle,
  productInfoContainerStyles
};
